// RecordEditLogList - MODULE
// ***********************************************************************************************************************
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { infiniteListPageSize } from "../../../models/common/webConsts";
import { IRecordEditItemLogListItem } from "../../../models/record/recordEditItemLogListItem";
import * as recordService from "../../../models/services/recordService";
import { ActionContainer } from "../../framework/ActionContainer";
import { List } from "../../framework/List/List";
import { ListSearchFilter } from "../../framework/List/ListSearchFilter";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

// RecordEditLogList
export interface IRecordEditLogListProp {
    companyId: string;
    recordId: string;
    userCode: string;
}

interface IRecordEditLogListState {
    // List
    intialized: boolean;
    isLoading: boolean;
    items: IRecordEditItemLogListItem[];
    pageSize: number;
    page: number;
    hasMore: boolean;
    filter: string;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    selectedId: string;
}

export class RecordEditLogList extends React.Component<IRecordEditLogListProp, IRecordEditLogListState> {
    constructor(props: IRecordEditLogListProp) {
        super(props);
        this.state = {
            intialized: false,
            isLoading: false,
            items: [],
            pageSize: infiniteListPageSize,
            page: 1,
            hasMore: true,
            filter: "",
            sortColumn: "modifyDate",
            sortOrderIsAsc: false,
            selectedId: null
        };
    }

    searchItems = async (pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, resetItems: boolean, refreshList: boolean) => {
        const props = this.props;
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => recordService.getRecordEditItemLogListItems(props.companyId, props.recordId, props.userCode, filter, !refreshList ? pageSize : (page * pageSize), !refreshList ? page : 1, sortColumn, sortOrderIsAsc),
            false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const items = List.getListItems(this.state.items, this.state.selectedId, [], result.items, resetItems, refreshList);
        this.setState({
            intialized: true,
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            filter,
            sortColumn,
            sortOrderIsAsc,
            items: items.items
        });
    };

    componentDidMount(): void {
        const state = this.state;
        this.searchItems(state.pageSize, state.page, state.filter, state.sortColumn, state.sortOrderIsAsc, false, false);
    }

    changeFilter = (filter: string) => {
        const state = this.state;
        this.searchItems(state.pageSize, 1, filter, state.sortColumn, state.sortOrderIsAsc, true, false);
    };

    handleSearchLines = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, state.filter, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            selectedId,
        });
    };

    render() {
        const state = this.state;
        return (
            <VerticalContainer
                before={<>
                    <ActionContainer
                        leftItems={
                            <ListSearchFilter
                                searchFilter={state.filter}
                                onSearchClick={this.changeFilter}
                            />
                        }
                    />
                </>}
                main={
                    <List
                        intialized={state.intialized}
                        isLoading={state.isLoading}
                        hasMore={state.hasMore}
                        globalLoadingInUse={true}
                        height="100%"
                        header={{
                            columns: [
                                { size: 2, column: "modifyDate", content: Translations.Time },
                                { size: 2, column: "userCode", content: Translations.UserName },
                                { size: 3, column: "userName", content: Translations.Name },
                                { size: 3, column: "entryType", content: Translations.Operation },
                                { size: 2, column: "callerIp", content: Translations.IpAddress }
                            ]
                        }}
                        lines={
                            state.items.map((logLine) => {
                                return {
                                    columns: [
                                        { size: 2, column: "code", content: Base.timeToDateTimeStr(logLine.modifyUser.date) },
                                        { size: 2, column: "userCode", content: logLine.modifyUser.code },
                                        { size: 3, column: "userName", content: logLine.modifyUser.name },
                                        { size: 3, column: "entryType", content: logLine.entryTypeStr },
                                        { size: 2, column: "callerIp", content: logLine.callerIp },
                                    ],
                                    id: logLine.id
                                };
                            })
                        }
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        selectedId={state.selectedId}
                        checkedIds={[]}
                        onSetSelectedIds={this.handleSetSelectedIds}
                        onSearchLines={this.handleSearchLines}
                    />
                }
            />
        );
    }
}